/**
 * @generated SignedSource<<abf9ff21884fd0152ad9fb3466f19187>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnboardingTermsScreenQuery$variables = Record<PropertyKey, never>;
export type OnboardingTermsScreenQuery$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"OnboardingTermsView_user">;
  } | null | undefined;
};
export type OnboardingTermsScreenQuery = {
  response: OnboardingTermsScreenQuery$data;
  variables: OnboardingTermsScreenQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingTermsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OnboardingTermsView_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OnboardingTermsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "acceptableUseAgreedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailNotificationsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPushNotificationsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailMarketingEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "privacyAgreedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "termsAgreedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "28ad325e3e69051be4da1c71977f1b4e",
    "id": null,
    "metadata": {},
    "name": "OnboardingTermsScreenQuery",
    "operationKind": "query",
    "text": "query OnboardingTermsScreenQuery {\n  currentUser {\n    ...OnboardingTermsView_user\n    id\n  }\n}\n\nfragment OnboardingTermsView_user on User {\n  acceptableUseAgreedAt\n  isEmailNotificationsEnabled\n  isPushNotificationsEnabled\n  isEmailMarketingEnabled\n  privacyAgreedAt\n  rowId\n  termsAgreedAt\n  ...useSetUserEmailNotificationsEnabledMutation_user\n  ...useSetUserEmailMarketingEnabledMutation_user\n  ...useSetUserIsMetricSystemMutation_user\n}\n\nfragment useSetUserEmailMarketingEnabledMutation_user on User {\n  rowId\n}\n\nfragment useSetUserEmailNotificationsEnabledMutation_user on User {\n  rowId\n}\n\nfragment useSetUserIsMetricSystemMutation_user on User {\n  rowId\n}\n"
  }
};

(node as any).hash = "b953baabae841c4abd34d44977db55f8";

export default node;
